import type { TextConfig as TextConfigType } from './types';

export type TextConfig = TextConfigType;

export const defaultTextConfig: TextConfig = {
  headerText: 'How can we help you today?',
  searchPlaceholder: 'Ask a question or type a search term here ...',
  attachImageText: 'Attach image',
  allDocumentsText: 'All documents',
  loadingSearchText: 'Searching for relevant content...',
  loadingAnswerText: 'Crafting a response...',
  errorText: 'Sorry, we were unable to process the request right now. Please try again in a moment.',
  followUpPlaceholder: 'Type your response or follow-up',
  positiveAnswerText: 'Helpful',
  negativeAnswerText: 'Not helpful',
  uncertaintyFallbackText: {
    'en': "Sorry, I can't find a clear answer to your question. Please try rephrasing or check the related sources below.",
    'es': 'Lo siento, no puedo encontrar una respuesta clara. Intente reformular la pregunta o consulte las fuentes relacionadas.',
    'fr': 'Désolé, je ne trouve pas de réponse claire. Essayez de reformuler ou consultez les sources connexes.',
    'de': 'Entschuldigung, ich finde keine klare Antwort. Versuchen Sie es anders zu formulieren oder sehen Sie sich die verwandten Quellen an.',
    'it': 'Mi dispiace, non trovo una risposta chiara. Prova a riformulare o consulta le fonti correlate.',
    'pt': 'Desculpe, não encontro uma resposta clara. Tente reformular ou consulte as fontes relacionadas.',
    'nl': 'Sorry, ik kan geen duidelijk antwoord vinden. Probeer het anders te formuleren of bekijk de gerelateerde bronnen.',
    'pl': 'Przepraszam, nie znajduję jasnej odpowiedzi. Spróbuj przeformułować pytanie lub sprawdź powiązane źródła.',
    'ru': 'Извините, я не могу найти четкого ответа. Попробуйте переформулировать или ознакомьтесь со связанными источниками.',
    'ja': '申し訳ありませんが、明確な回答が見つかりません。質問の言い換えや、関連ソースをご確認ください。',
    'ko': '죄송합니다. 명확한 답변을 찾을 수 없습니다. 질문을 다시 작성하거나 관련 소스를 확인해 주세요.',
    'zh': '抱歉，找不到明确的答案。请尝试重新表述或查看相关来源。',
    'zh-TW': '抱歉，找不到明確的答案。請嘗試重新表述或查看相關來源。',
  },
};
